export { default as PageNotFound } from './PageNotFound';
export { default as SimpleTable } from './SimpleTable';



// WEBPACK FOOTER //
// ./src/features/common/index.js